import { useScrollAnim } from "../../hook/useScrollAnim";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import story1 from "../../../assets/img/projects/People/people-story1.png";
import story2 from "../../../assets/img/projects/People/people-story2.png";
import story3 from "../../../assets/img/projects/People/people-story3.png";

export default function Card() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const containerRef = useScrollAnim({
    selector: isMobile
      ? ".people-story .swiper-slide img"
      : ".people-story img",
    threshold: 0.25,
    once: true,
  });

  return (
    <div className="people-story" ref={containerRef}>
      {isMobile ? (
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 30 }}
          modules={[Pagination]}
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <img src={story1} alt="Story 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={story2} alt="Story 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={story3} alt="Story 3" />
          </SwiperSlide>
        </Swiper>
      ) : (
        <>
          <img src={story1} alt="Story 1" />
          <img src={story2} alt="Story 2" />
          <img src={story3} alt="Story 3" />
        </>
      )}
    </div>
  );
}
